import {getTodayStartTime, getTomorrowStartTime} from 'shared/utils/dateTime';

export function todayPeriod(): Period {
  return {
    from: getTodayStartTime(),
    to: getTomorrowStartTime(),
  };
}
